module.exports = __webpack_public_path__ + "img/theme6.b2f698af.png";